import { Component, OnInit, } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';
import { StateService } from '../shared/services/state.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {

	processingRequest: boolean = false;
	stepNum: number = 0;

	readonly loginForm = new FormGroup({
		email: new FormControl<string>('', [Validators.required, Validators.email]),
		password: new FormControl<string>('', [Validators.required])
	});
	
	constructor(
		private readonly _router: Router,
		private readonly _authService: AuthService,
		private readonly _route: ActivatedRoute,
		private readonly _state: StateService
	) { }

	ngOnInit(): void {
		this.trySetCurrentEmail();
		this._route.paramMap.subscribe((params: ParamMap) => {
			let step = params.get("step");
			if (step) {
				this.stepNum = +step;
				if (this.stepNum > 0 && !this._state.currentLoginEmail) {
					this._router.navigate(["/login"], { queryParamsHandling: "merge" });
				}
			}
		});
	}

	private trySetCurrentEmail() {
		if (this._state.currentLoginEmail) {
			this.loginForm.get("email")?.setValue(this._state.currentLoginEmail);
		}
	}

	get stepValid(): boolean {
		if (this.stepNum == 0) {
			return this.loginForm.controls.email!.valid;
		}
		else {
			return this.loginForm.valid;
		}
	}

	public nextStep() {
		if (!this.stepValid) {
			return;
		}
		this._state.currentLoginEmail = this.loginForm.get("email")!.value!;
		this.stepNum++;
		this._router.navigate(["/login", this.stepNum], { queryParamsHandling: "merge" });
	}

	public login() {
		if (!this.loginForm.valid) {
			return;
		}
		this.processingRequest = true;		
		this._authService.loginByEmail(this.loginForm.get("email")!.value!, this.loginForm.get("password")!.value!)
			.pipe(
				finalize(() => {
					this.processingRequest = false;
				})
			)
			.subscribe({
				next: (v) => {
					if (this._authService.returnUrl) {
						window.location.href = this._authService.returnUrl;
					}
					else {
						this._router.navigate(["/profile"], { queryParamsHandling: "preserve" });
					}
				},
				error: (e) => {
					console.log(e);
				}
			})
	}
}
